import { render, staticRenderFns } from "./messageInfo.vue?vue&type=template&id=dca39cf0&scoped=true"
import script from "./messageInfo.vue?vue&type=script&lang=js"
export * from "./messageInfo.vue?vue&type=script&lang=js"
import style0 from "./messageInfo.vue?vue&type=style&index=0&id=dca39cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca39cf0",
  null
  
)

export default component.exports